/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, useMemo, Image, Input } from "@";
import { useWatch } from "react-hook-form";
import { useProjectQuery } from "@/features/donations/projects/api/queries";
import { useProjectsOptionsQuery } from "@/shared/hooks";
import { donateTypeOptions } from "@/features/donations/projects/lib/options.ts";

interface Props {
  setValue: any;
  control: any;
  errors: any;
  show?: string | undefined;
}

interface ProjectOption {
  value: number;
  label: string;
}

export const ProjectSelectionSection = ({
  setValue,
  control,
  errors,
  show,
}: Props) => {
  const isDisabled = !!show;
  const projectId = useWatch({ control, name: "projectId" }) as number | null;

  const { data: projectsList = [] } = useProjectsOptionsQuery({
    isArchived: false,
    isActive: true,
    isCompleted: false,
  });

  const { data: projectDetail, isLoading: isDetailLoading } = useProjectQuery(
    projectId ?? undefined,
  );

  const selectedOption = useMemo<ProjectOption | null>(() => {
    if (!projectId) return null;
    return (
      (projectsList as ProjectOption[]).find((o) => o.value === projectId) ??
      null
    );
  }, [projectsList, projectId]);

  return (
    <Card title="اختيار المشروع">
      <p className="mb-3 text-xs text-gray-500 dark:text-gray-400">
        ابحث عن المشروع الذي ستربطه بصفحة الهبوط. ستظهر تفاصيل المشروع تحت الحقل
        بعد الاختيار للتأكد من اختيار المشروع الصحيح.
      </p>

      <Input
        disabled={isDisabled}
        label=" المشروع"
        list={projectsList}
        type="select-searchable"
        error={errors.projectId}
        value={selectedOption}
        change={(e: { value: number } | null) =>
          setValue("projectId", e?.value ?? null, {
            shouldDirty: true,
            shouldValidate: true,
          })
        }
      />

      {projectId && (
        <div className="card mt-5 p-3">
          {isDetailLoading && (
            <p className="text-sm text-gray-500">
              جاري تحميل تفاصيل المشروع...
            </p>
          )}
          {projectDetail && (
            <div className="flex flex-col items-start justify-start gap-4 md:flex-row">
              <Image
                className="rounded-lg"
                size={64}
                src={projectDetail.imageUrl}
              />
              <div className="flex flex-col items-start justify-center gap-2">
                <h4 className="text-base font-bold text-gray-800 dark:text-gray-100">
                  {projectDetail.title}
                </h4>

                <p className="rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-800">
                  <span>نوع التبرع:</span>

                  {
                    donateTypeOptions?.find(
                      (o) => o.value === projectDetail.category,
                    )?.name
                  }
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {projectDetail.name}
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {projectDetail.shortDescription}
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </Card>
  );
};
